module.exports = __webpack_public_path__ + "img/promotion-feature-logo-example.723ac8c6.png";